import { Variants } from 'framer-motion';

interface AnimationVariants {
  subtitle: Variants;
  waveText: Variants;
  word: Variants;
}

export const heroAnimations: AnimationVariants = {
  subtitle: {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, delay: 0.2 } },
  },
  waveText: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.4,
        repeat: Infinity,
        duration: 3,
        delay: 1,
      },
    },
  },
  word: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.08 },
    },
  },
} as const;
